import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withKeys as _withKeys, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, Fragment as _Fragment, renderList as _renderList, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "admin-console-page board-page" }
const _hoisted_2 = { class: "console-page-head" }
const _hoisted_3 = {
  key: 0,
  class: "console-head-side"
}
const _hoisted_4 = { class: "board-search" }
const _hoisted_5 = {
  key: 0,
  class: "console-alert"
}
const _hoisted_6 = {
  key: 1,
  class: "board-article"
}
const _hoisted_7 = { class: "board-article-head" }
const _hoisted_8 = {
  key: 0,
  class: "board-flag is-notice"
}
const _hoisted_9 = {
  key: 1,
  class: "notice-pin"
}
const _hoisted_10 = {
  key: 2,
  class: "board-new"
}
const _hoisted_11 = {
  key: 3,
  class: "board-flag is-update"
}
const _hoisted_12 = { class: "board-article-title" }
const _hoisted_13 = { class: "board-article-meta" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "board-article-actions" }
const _hoisted_17 = {
  key: 0,
  class: "board-locked"
}
const _hoisted_18 = {
  key: 2,
  class: "board-reply"
}
const _hoisted_19 = { class: "board-reply-meta" }
const _hoisted_20 = {
  key: 1,
  class: "board-reply-empty"
}
const _hoisted_21 = {
  key: 0,
  class: "console-alert"
}
const _hoisted_22 = { class: "board-compose-actions" }
const _hoisted_23 = {
  key: 3,
  class: "board-comments"
}
const _hoisted_24 = {
  key: 0,
  class: "board-comment-list"
}
const _hoisted_25 = { class: "board-comment-meta" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { class: "board-compose-actions" }
const _hoisted_29 = {
  key: 1,
  class: "board-reply-empty"
}
const _hoisted_30 = {
  key: 2,
  class: "console-alert"
}
const _hoisted_31 = { class: "board-compose-actions" }
const _hoisted_32 = { class: "board-near" }
const _hoisted_33 = ["disabled"]
const _hoisted_34 = ["disabled"]
const _hoisted_35 = {
  key: 2,
  class: "board-tabs"
}
const _hoisted_36 = {
  key: 3,
  class: "board-sheet"
}
const _hoisted_37 = {
  key: 0,
  class: "console-empty"
}
const _hoisted_38 = {
  key: 1,
  class: "console-empty"
}
const _hoisted_39 = {
  key: 2,
  class: "board-table"
}
const _hoisted_40 = ["onClick"]
const _hoisted_41 = { class: "board-title-line" }
const _hoisted_42 = {
  key: 0,
  class: "board-flag is-hide"
}
const _hoisted_43 = {
  key: 1,
  class: "board-new"
}
const _hoisted_44 = { class: "board-title" }
const _hoisted_45 = { class: "col-who" }
const _hoisted_46 = { class: "col-date" }
const _hoisted_47 = { class: "col-hit" }
const _hoisted_48 = { class: "col-cmt" }
const _hoisted_49 = ["onClick"]
const _hoisted_50 = { class: "col-no" }
const _hoisted_51 = { class: "board-title-line" }
const _hoisted_52 = {
  key: 0,
  class: "notice-pin"
}
const _hoisted_53 = {
  key: 1,
  class: "board-flag is-notice"
}
const _hoisted_54 = {
  key: 2,
  class: "board-flag is-ask"
}
const _hoisted_55 = {
  key: 3,
  class: "board-flag is-update"
}
const _hoisted_56 = {
  key: 4,
  class: "board-flag is-hide"
}
const _hoisted_57 = {
  key: 5,
  class: "board-new"
}
const _hoisted_58 = {
  key: 6,
  class: "board-flag is-done"
}
const _hoisted_59 = { class: "board-title" }
const _hoisted_60 = { class: "col-who" }
const _hoisted_61 = { class: "col-date" }
const _hoisted_62 = { class: "col-hit" }
const _hoisted_63 = { class: "col-cmt" }
const _hoisted_64 = {
  key: 4,
  class: "board-compose"
}
const _hoisted_65 = { class: "board-compose-title" }
const _hoisted_66 = {
  key: 0,
  class: "kind-picks"
}
const _hoisted_67 = { class: "console-field" }
const _hoisted_68 = { class: "console-field" }
const _hoisted_69 = {
  key: 1,
  class: "console-check"
}
const _hoisted_70 = {
  key: 2,
  class: "notice-form-options"
}
const _hoisted_71 = {
  key: 0,
  class: "console-check"
}
const _hoisted_72 = { class: "console-field console-field--inline" }
const _hoisted_73 = {
  key: 3,
  class: "console-alert"
}
const _hoisted_74 = { class: "board-compose-actions" }

import { computed, onMounted, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { boardApi } from '@/services/api';
import BoardBody from '@/components/admin/BoardBody.vue';
import PasteImageField from '@/components/admin/PasteImageField.vue';
import TablePagination from '@/components/common/TablePagination.vue';

type Kind = 'N' | 'Q' | 'P';
type Tab = 'A' | Kind;

interface BoardItem {
  idx: number;
  kind: Kind;
  title: string;
  body: string;
  secret: boolean;
  pinned: boolean;
  status: 'Y' | 'N';
  answerStatus: '-' | 'W' | 'A';
  authorName: string;
  reply: string;
  replyName: string;
  replyAt: string | null;
  createdAt: string | null;
  hit: number;
  commentCount: number;
  mine: boolean;
  locked: boolean;
  preview: string;
  newer: NearPost | null;
  older: NearPost | null;
  comments: BoardComment[];
}

interface NearPost {
  idx: number;
  title: string;
  createdAt: string | null;
}

interface BoardComment {
  idx: number;
  body: string;
  authorName: string;
  createdAt: string | null;
  mine: boolean;
}

const NEW_NOTICE_MS = 7 * 24 * 60 * 60 * 1000;


export default /*@__PURE__*/_defineComponent({
  __name: 'BoardPage',
  setup(__props) {

const store = useStore();
const route = useRoute();
const router = useRouter();
const level = computed(() => Number(store.getters.actualRoleLevel || store.getters.roleLevel || 0));
const canNotice = computed(() => level.value >= 80);
const canAnswer = computed(() => level.value >= 80);

const posts = ref<BoardItem[]>([]);
const pinned = ref<BoardItem[]>([]);
const tab = ref<Tab>('A');
const keyword = ref('');
const searchField = ref<'title' | 'author'>('title');
const page = ref(1);
const limit = ref(15);
const totalCount = ref(0);
const loading = ref(false);
const saving = ref(false);
const replying = ref(false);
const errorText = ref('');
const formError = ref('');
const replyError = ref('');
const screen = ref<'list' | 'read' | 'write'>('list');
const reading = ref<BoardItem | null>(null);
const editingId = ref<number | null>(null);
const editorKey = ref(0);
const replyKey = ref(0);
const replyText = ref('');
const commentText = ref('');
const commentError = ref('');
const commenting = ref(false);
const commentKey = ref(0);
const editingCommentId = ref<number | null>(null);
const editCommentText = ref('');
const editCommentKey = ref(0);
const commentSaving = ref(false);
const form = ref({
  kind: 'Q' as Kind,
  title: '',
  body: '',
  secret: false,
  pinned: false,
  status: 'Y' as 'Y' | 'N',
});

const totalPages = computed(() => Math.max(1, Math.ceil(totalCount.value / limit.value)));

const rowNo = (index: number) => totalCount.value - (page.value - 1) * limit.value - index;

const isNewNotice = (item: { kind?: string; createdAt: string | null }) => {
  if (item.kind !== 'N' || !item.createdAt) return false;
  const posted = new Date(String(item.createdAt).replace(' ', 'T'));
  if (Number.isNaN(posted.getTime())) return false;
  const age = Date.now() - posted.getTime();
  return age >= 0 && age < NEW_NOTICE_MS;
};

const formatDate = (value: string | null) => (value ? String(value).substring(0, 10) : '');
const formatDateTime = (value: string | null) => (value ? String(value).substring(0, 16).replace('T', ' ') : '');

const canEdit = computed(() => {
  const item = reading.value;
  if (!item || item.locked) return false;
  if (item.kind === 'N' || item.kind === 'P') return canNotice.value;
  return item.mine && item.answerStatus !== 'A';
});

const canRemove = computed(() => {
  const item = reading.value;
  if (!item) return false;
  if (item.kind === 'N' || item.kind === 'P') return canNotice.value;
  if (canAnswer.value) return true;
  return item.mine && item.answerStatus !== 'A';
});

const load = async () => {
  loading.value = true;
  errorText.value = '';
  try {
    const res = await boardApi.list({
      page: page.value,
      limit: limit.value,
      keyword: keyword.value.trim() || undefined,
      field: searchField.value,
      kind: tab.value,
    });
    pinned.value = res.data?.data?.pinned || [];
    posts.value = res.data?.data?.posts || [];
    totalCount.value = Number(res.data?.data?.pagination?.total) || 0;
  } catch (error) {
    console.error('게시판 목록 실패:', error);
    errorText.value = '게시판을 불러오지 못했습니다.';
  } finally {
    loading.value = false;
  }
};

const setTab = (next: Tab) => {
  if (tab.value === next) return;
  tab.value = next;
  page.value = 1;
  load();
};

const search = () => {
  page.value = 1;
  load();
};

const onPage = (next: number) => {
  page.value = next;
  load();
};

const onLimit = (next: number) => {
  limit.value = next;
  page.value = 1;
  load();
};

const readPost = async (idx: number, peek = false) => {
  const res = await boardApi.detail(idx, {
    keyword: keyword.value.trim() || undefined,
    field: searchField.value,
    nav: tab.value,
    ...(peek ? { peek: 1 } : {}),
  });
  reading.value = res.data?.data || null;
  replyText.value = reading.value?.reply || '';
};

const postIdFromRoute = () => {
  const raw = route.query.post;
  const value = Array.isArray(raw) ? raw[0] : raw;
  const idx = Number(value);
  return Number.isFinite(idx) && idx > 0 ? idx : 0;
};

let readToken = 0;

const showPost = async (idx: number) => {
  const token = ++readToken;
  try {
    await readPost(idx);
    if (token !== readToken || postIdFromRoute() !== idx) return;
    replyError.value = '';
    commentError.value = '';
    commentText.value = '';
    commentKey.value += 1;
    replyKey.value += 1;
    screen.value = 'read';
    window.scrollTo({ top: 0, behavior: 'smooth' });
  } catch (error) {
    if (token !== readToken) return;
    errorText.value = '글을 불러오지 못했습니다.';
  }
};

const openRead = (item: { idx: number }, replace = false) => {
  if (postIdFromRoute() === item.idx && screen.value === 'read') return;
  const query = { ...route.query, post: String(item.idx) };
  if (replace) router.replace({ name: 'board', query });
  else router.push({ name: 'board', query });
};

const openNear = (item: NearPost | null) => {
  if (!item) return;
  openRead(item, true);
};

const listQuery = () => {
  const query = { ...route.query };
  delete query.post;
  return query;
};

const cameFromList = () => {
  const back = window.history.state?.back;
  return typeof back === 'string' && back.split('?')[0] === '/board' && !/[?&]post=/.test(back);
};

const openCreate = () => {
  editingId.value = null;
  const nextKind: Kind = (tab.value === 'N' || tab.value === 'P') && canNotice.value ? tab.value : 'Q';
  form.value = {
    kind: nextKind,
    title: '',
    body: '',
    secret: false,
    pinned: false,
    status: 'Y',
  };
  formError.value = '';
  editorKey.value += 1;
  screen.value = 'write';
};

const backList = () => {
  if (!postIdFromRoute()) {
    screen.value = 'list';
    return;
  }
  if (cameFromList()) {
    router.back();
    return;
  }
  router.replace({ name: 'board', query: listQuery() });
};

const openEdit = () => {
  if (!reading.value) return;
  editingId.value = reading.value.idx;
  form.value = {
    kind: reading.value.kind,
    title: reading.value.title,
    body: reading.value.body,
    secret: reading.value.secret,
    pinned: reading.value.pinned,
    status: reading.value.status === 'N' ? 'N' : 'Y',
  };
  formError.value = '';
  editorKey.value += 1;
  screen.value = 'write';
};

const save = async () => {
  formError.value = '';
  const title = form.value.title.trim();
  const body = form.value.body.trim();
  if (!title) {
    formError.value = '제목을 입력해 주세요.';
    return;
  }
  if (!body) {
    formError.value = '내용을 입력해 주세요.';
    return;
  }
  if (editingId.value && !window.confirm('수정한 내용을 저장할까요?')) return;
  saving.value = true;
  try {
    if (editingId.value) {
      await boardApi.update(editingId.value, {
        title,
        body,
        secret: form.value.secret,
        pinned: form.value.pinned,
        status: form.value.status,
      });
    } else {
      await boardApi.create({
        kind: form.value.kind,
        title,
        body,
        secret: form.value.secret,
        pinned: form.value.pinned,
        status: form.value.status,
      });
    }
    tab.value = form.value.kind;
    page.value = 1;
    if (postIdFromRoute()) {
      if (cameFromList()) router.back();
      else router.replace({ name: 'board', query: listQuery() });
    } else {
      screen.value = 'list';
    }
    await load();
  } catch (error: any) {
    formError.value = error?.response?.data?.message || '저장에 실패했습니다.';
  } finally {
    saving.value = false;
  }
};

const saveReply = async () => {
  if (!reading.value) return;
  replyError.value = '';
  if (!replyText.value.trim()) {
    replyError.value = '답변 내용을 입력해 주세요.';
    return;
  }
  const replyAsk = reading.value.reply ? '답변을 수정할까요?' : '답변을 등록할까요?';
  if (!window.confirm(replyAsk)) return;
  replying.value = true;
  try {
    await boardApi.reply(reading.value.idx, replyText.value.trim());
    await readPost(reading.value.idx, true);
    await load();
  } catch (error: any) {
    replyError.value = error?.response?.data?.message || '답변 저장에 실패했습니다.';
  } finally {
    replying.value = false;
  }
};

const saveComment = async () => {
  if (!reading.value) return;
  commentError.value = '';
  if (!commentText.value.trim()) {
    commentError.value = '댓글을 입력해 주세요.';
    return;
  }
  commenting.value = true;
  try {
    await boardApi.comment(reading.value.idx, commentText.value.trim());
    commentText.value = '';
    commentKey.value += 1;
    await readPost(reading.value.idx, true);
    await load();
  } catch (error: any) {
    commentError.value = error?.response?.data?.message || '댓글을 등록하지 못했습니다.';
  } finally {
    commenting.value = false;
  }
};

const canTouchComment = (comment: BoardComment) => comment.mine || canAnswer.value;

const startEditComment = (comment: BoardComment) => {
  editingCommentId.value = comment.idx;
  editCommentText.value = comment.body;
  editCommentKey.value += 1;
  commentError.value = '';
};

const cancelEditComment = () => {
  editingCommentId.value = null;
  editCommentText.value = '';
};

const saveEditComment = async () => {
  if (!reading.value || !editingCommentId.value) return;
  commentError.value = '';
  if (!editCommentText.value.trim()) {
    commentError.value = '댓글을 입력해 주세요.';
    return;
  }
  if (!window.confirm('댓글 수정을 저장할까요?')) return;
  commentSaving.value = true;
  try {
    await boardApi.updateComment(reading.value.idx, editingCommentId.value, editCommentText.value.trim());
    cancelEditComment();
    await readPost(reading.value.idx, true);
    await load();
  } catch (error: any) {
    commentError.value = error?.response?.data?.message || '댓글을 수정하지 못했습니다.';
  } finally {
    commentSaving.value = false;
  }
};

const removeComment = async (comment: BoardComment) => {
  if (!reading.value) return;
  if (!window.confirm('이 댓글을 삭제할까요?')) return;
  try {
    await boardApi.removeComment(reading.value.idx, comment.idx);
    if (editingCommentId.value === comment.idx) cancelEditComment();
    await readPost(reading.value.idx, true);
    await load();
  } catch (error) {
    commentError.value = '댓글을 삭제하지 못했습니다.';
  }
};

const togglePin = async () => {
  const item = reading.value;
  if (!item || item.kind !== 'N') return;
  const next = !item.pinned;
  const ask = next ? '이 공지를 목록 상단에 고정할까요?' : '상단 고정을 해제할까요?';
  if (!window.confirm(ask)) return;
  try {
    await boardApi.update(item.idx, {
      title: item.title,
      body: item.body,
      secret: item.secret,
      pinned: next,
      status: item.status,
    });
    await readPost(item.idx, true);
    await load();
  } catch (error) {
    errorText.value = '고정을 바꾸지 못했습니다.';
  }
};

const askRemove = async () => {
  if (!reading.value) return;
  if (!window.confirm('이 글을 삭제할까요?')) return;
  try {
    await boardApi.remove(reading.value.idx);
    reading.value = null;
    if (postIdFromRoute()) {
      if (cameFromList()) router.back();
      else router.replace({ name: 'board', query: listQuery() });
    } else {
      screen.value = 'list';
    }
    await load();
  } catch (error) {
    errorText.value = '삭제에 실패했습니다.';
  }
};

watch(() => route.query.post, () => {
  const idx = postIdFromRoute();
  if (!idx) {
    readToken += 1;
    if (screen.value !== 'list') screen.value = 'list';
    return;
  }
  if (screen.value === 'read' && reading.value?.idx === idx) return;
  showPost(idx);
});

onMounted(async () => {
  await load();
  const idx = postIdFromRoute();
  if (idx) showPost(idx);
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _cache[22] || (_cache[22] = _createElementVNode("div", { class: "console-page-copy" }, [
        _createElementVNode("p", { class: "console-kicker" }, "운영"),
        _createElementVNode("h2", { class: "console-title" }, "게시판")
      ], -1)),
      (screen.value === 'list')
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("label", _hoisted_4, [
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchField).value = $event))
              }, [...(_cache[19] || (_cache[19] = [
                _createElementVNode("option", { value: "title" }, "제목", -1),
                _createElementVNode("option", { value: "author" }, "작성자", -1)
              ]))], 512), [
                [_vModelSelect, searchField.value]
              ]),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((keyword).value = $event)),
                type: "text",
                placeholder: "검색",
                onKeydown: _withKeys(search, ["enter"])
              }, null, 544), [
                [_vModelText, keyword.value]
              ])
            ]),
            _createVNode(_component_v_btn, {
              variant: "flat",
              class: "btn-register",
              onClick: openCreate
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  size: "16",
                  class: "mr-1"
                }, {
                  default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                    _createTextVNode("mdi-plus", -1)
                  ]))]),
                  _: 1
                }),
                _cache[21] || (_cache[21] = _createTextVNode(" 글쓰기 ", -1))
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (screen.value === 'write')
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            type: "button",
            class: "board-back",
            onClick: backList
          }, "목록으로"))
        : _createCommentVNode("", true)
    ]),
    (errorText.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(errorText.value), 1))
      : _createCommentVNode("", true),
    (screen.value === 'read' && reading.value)
      ? (_openBlock(), _createElementBlock("article", _hoisted_6, [
          _createElementVNode("header", _hoisted_7, [
            (reading.value.kind === 'N')
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, "공지사항"))
              : _createCommentVNode("", true),
            (reading.value.pinned)
              ? (_openBlock(), _createElementBlock("span", _hoisted_9, "고정"))
              : _createCommentVNode("", true),
            (isNewNotice(reading.value))
              ? (_openBlock(), _createElementBlock("span", _hoisted_10, "신규"))
              : _createCommentVNode("", true),
            (reading.value.kind === 'P')
              ? (_openBlock(), _createElementBlock("span", _hoisted_11, "업데이트"))
              : _createCommentVNode("", true),
            _createElementVNode("h3", _hoisted_12, _toDisplayString(reading.value.title), 1),
            _createElementVNode("p", _hoisted_13, [
              _createTextVNode(_toDisplayString(reading.value.authorName || '관리자') + " ", 1),
              _createElementVNode("span", null, _toDisplayString(formatDateTime(reading.value.createdAt)), 1),
              _createElementVNode("span", null, "조회 " + _toDisplayString(reading.value.hit), 1),
              (reading.value.secret)
                ? (_openBlock(), _createElementBlock("span", _hoisted_14, "비밀글"))
                : _createCommentVNode("", true),
              (reading.value.kind === 'Q')
                ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(reading.value.answerStatus === 'A' ? '답변 완료' : '답변 대기'), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_16, [
              (canNotice.value && reading.value.kind === 'N')
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "board-text-btn",
                    onClick: togglePin
                  }, _toDisplayString(reading.value.pinned ? '고정 해제' : '상단 고정'), 1))
                : _createCommentVNode("", true),
              (canEdit.value)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    type: "button",
                    class: "board-text-btn",
                    onClick: openEdit
                  }, "수정"))
                : _createCommentVNode("", true),
              (canRemove.value)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 2,
                    type: "button",
                    class: "board-text-btn is-danger",
                    onClick: askRemove
                  }, "삭제"))
                : _createCommentVNode("", true)
            ])
          ]),
          (reading.value.locked)
            ? (_openBlock(), _createElementBlock("p", _hoisted_17, "비밀글입니다."))
            : (_openBlock(), _createBlock(BoardBody, {
                key: 1,
                class: "board-article-body",
                body: reading.value.body
              }, null, 8, ["body"])),
          (reading.value.kind === 'Q' && !reading.value.locked)
            ? (_openBlock(), _createElementBlock("section", _hoisted_18, [
                _cache[24] || (_cache[24] = _createElementVNode("h4", null, "답변", -1)),
                (reading.value.reply)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("p", _hoisted_19, _toDisplayString(reading.value.replyName || '관리자') + " · " + _toDisplayString(formatDateTime(reading.value.replyAt)), 1),
                      _createVNode(BoardBody, {
                        body: reading.value.reply
                      }, null, 8, ["body"])
                    ], 64))
                  : (!canAnswer.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_20, "아직 답변이 없습니다."))
                    : _createCommentVNode("", true),
                (canAnswer.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      (_openBlock(), _createBlock(PasteImageField, {
                        key: replyKey.value,
                        modelValue: replyText.value,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((replyText).value = $event)),
                        placeholder: "답변을 입력하세요. 사진은 붙여넣기 하면 들어갑니다."
                      }, null, 8, ["modelValue"])),
                      (replyError.value)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_21, _toDisplayString(replyError.value), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_22, [
                        _createVNode(_component_v_btn, {
                          variant: "flat",
                          class: "btn-save",
                          loading: replying.value,
                          onClick: saveReply
                        }, {
                          default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                            _createTextVNode("답변 저장", -1)
                          ]))]),
                          _: 1
                        }, 8, ["loading"])
                      ])
                    ], 64))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (!reading.value.locked)
            ? (_openBlock(), _createElementBlock("section", _hoisted_23, [
                _createElementVNode("h4", null, "댓글 " + _toDisplayString(reading.value.comments.length), 1),
                (reading.value.comments.length)
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_24, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reading.value.comments, (comment) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: comment.idx
                        }, [
                          _createElementVNode("div", _hoisted_25, [
                            _createElementVNode("span", null, _toDisplayString(comment.authorName || '매니저'), 1),
                            _createElementVNode("span", null, _toDisplayString(formatDateTime(comment.createdAt)), 1),
                            (canTouchComment(comment) && editingCommentId.value !== comment.idx)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  type: "button",
                                  class: "board-text-btn",
                                  onClick: ($event: any) => (startEditComment(comment))
                                }, "수정", 8, _hoisted_26))
                              : _createCommentVNode("", true),
                            (canTouchComment(comment))
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 1,
                                  type: "button",
                                  class: "board-text-btn is-danger",
                                  onClick: ($event: any) => (removeComment(comment))
                                }, "삭제", 8, _hoisted_27))
                              : _createCommentVNode("", true)
                          ]),
                          (editingCommentId.value === comment.idx)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                (_openBlock(), _createBlock(PasteImageField, {
                                  key: editCommentKey.value,
                                  modelValue: editCommentText.value,
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((editCommentText).value = $event))
                                }, null, 8, ["modelValue"])),
                                _createElementVNode("div", _hoisted_28, [
                                  _createVNode(_component_v_btn, {
                                    variant: "text",
                                    class: "btn-cancel",
                                    disabled: commentSaving.value,
                                    onClick: cancelEditComment
                                  }, {
                                    default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                                      _createTextVNode("취소", -1)
                                    ]))]),
                                    _: 1
                                  }, 8, ["disabled"]),
                                  _createVNode(_component_v_btn, {
                                    variant: "flat",
                                    class: "btn-save",
                                    loading: commentSaving.value,
                                    onClick: saveEditComment
                                  }, {
                                    default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                                      _createTextVNode("저장", -1)
                                    ]))]),
                                    _: 1
                                  }, 8, ["loading"])
                                ])
                              ], 64))
                            : (_openBlock(), _createBlock(BoardBody, {
                                key: 1,
                                body: comment.body
                              }, null, 8, ["body"]))
                        ]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("p", _hoisted_29, "댓글이 없습니다.")),
                (_openBlock(), _createBlock(PasteImageField, {
                  key: commentKey.value,
                  modelValue: commentText.value,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((commentText).value = $event)),
                  placeholder: "댓글을 입력하세요. 사진은 붙여넣기 하면 들어갑니다."
                }, null, 8, ["modelValue"])),
                (commentError.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_30, _toDisplayString(commentError.value), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_31, [
                  _createVNode(_component_v_btn, {
                    variant: "flat",
                    class: "btn-save",
                    loading: commenting.value,
                    onClick: saveComment
                  }, {
                    default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                      _createTextVNode("댓글 등록", -1)
                    ]))]),
                    _: 1
                  }, 8, ["loading"])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("button", {
              type: "button",
              disabled: !reading.value.newer,
              onClick: _cache[5] || (_cache[5] = ($event: any) => (openNear(reading.value.newer)))
            }, [
              _cache[28] || (_cache[28] = _createElementVNode("span", null, "다음글", -1)),
              _createElementVNode("em", null, _toDisplayString(reading.value.newer?.title || '다음글이 없습니다'), 1)
            ], 8, _hoisted_33),
            _createElementVNode("button", {
              type: "button",
              disabled: !reading.value.older,
              onClick: _cache[6] || (_cache[6] = ($event: any) => (openNear(reading.value.older)))
            }, [
              _cache[29] || (_cache[29] = _createElementVNode("span", null, "이전글", -1)),
              _createElementVNode("em", null, _toDisplayString(reading.value.older?.title || '이전글이 없습니다'), 1)
            ], 8, _hoisted_34)
          ]),
          _createElementVNode("div", { class: "board-article-foot" }, [
            _createElementVNode("button", {
              type: "button",
              class: "board-foot-btn",
              onClick: backList
            }, "목록"),
            _createElementVNode("button", {
              type: "button",
              class: "board-foot-btn is-primary",
              onClick: openCreate
            }, "글쓰기")
          ])
        ]))
      : _createCommentVNode("", true),
    (screen.value === 'list')
      ? (_openBlock(), _createElementBlock("nav", _hoisted_35, [
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass({ 'is-on': tab.value === 'A' }),
            onClick: _cache[7] || (_cache[7] = ($event: any) => (setTab('A')))
          }, "전체", 2),
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass({ 'is-on': tab.value === 'N' }),
            onClick: _cache[8] || (_cache[8] = ($event: any) => (setTab('N')))
          }, "공지사항", 2),
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass({ 'is-on': tab.value === 'Q' }),
            onClick: _cache[9] || (_cache[9] = ($event: any) => (setTab('Q')))
          }, "문의요청", 2),
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass({ 'is-on': tab.value === 'P' }),
            onClick: _cache[10] || (_cache[10] = ($event: any) => (setTab('P')))
          }, "업데이트", 2)
        ]))
      : _createCommentVNode("", true),
    (screen.value === 'list')
      ? (_openBlock(), _createElementBlock("section", _hoisted_36, [
          (loading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_37, "불러오는 중"))
            : (!pinned.value.length && !posts.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_38, "등록된 글이 없습니다."))
              : (_openBlock(), _createElementBlock("table", _hoisted_39, [
                  _cache[33] || (_cache[33] = _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", { class: "col-no" }, "번호"),
                      _createElementVNode("th", null, "제목"),
                      _createElementVNode("th", { class: "col-who" }, "작성자"),
                      _createElementVNode("th", { class: "col-date" }, "등록일"),
                      _createElementVNode("th", { class: "col-hit" }, "조회"),
                      _createElementVNode("th", { class: "col-cmt" }, "댓글")
                    ])
                  ], -1)),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pinned.value, (item) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: `pin-${item.idx}`,
                        class: _normalizeClass(["is-notice", { 'is-current': screen.value === 'read' && reading.value?.idx === item.idx }]),
                        onClick: ($event: any) => (openRead(item))
                      }, [
                        _cache[31] || (_cache[31] = _createElementVNode("td", { class: "col-no" }, "공지", -1)),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", _hoisted_41, [
                            _cache[30] || (_cache[30] = _createElementVNode("span", { class: "notice-pin" }, "고정", -1)),
                            (item.status === 'N')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_42, "숨김"))
                              : _createCommentVNode("", true),
                            (isNewNotice(item))
                              ? (_openBlock(), _createElementBlock("span", _hoisted_43, "신규"))
                              : _createCommentVNode("", true),
                            _createElementVNode("span", _hoisted_44, _toDisplayString(item.title), 1)
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_45, _toDisplayString(item.authorName || '—'), 1),
                        _createElementVNode("td", _hoisted_46, _toDisplayString(formatDate(item.createdAt)), 1),
                        _createElementVNode("td", _hoisted_47, _toDisplayString(item.hit), 1),
                        _createElementVNode("td", _hoisted_48, _toDisplayString(item.commentCount), 1)
                      ], 10, _hoisted_40))
                    }), 128)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(posts.value, (item, index) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: `p-${item.idx}`,
                        class: _normalizeClass({ 'is-current': screen.value === 'read' && reading.value?.idx === item.idx, 'is-notice': item.kind === 'N' && item.pinned }),
                        onClick: ($event: any) => (openRead(item))
                      }, [
                        _createElementVNode("td", _hoisted_50, _toDisplayString(item.kind === 'N' && item.pinned ? '공지' : rowNo(index)), 1),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", _hoisted_51, [
                            (item.kind === 'N' && item.pinned)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_52, "고정"))
                              : _createCommentVNode("", true),
                            (tab.value === 'A' && item.kind === 'N')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_53, "공지"))
                              : _createCommentVNode("", true),
                            (tab.value === 'A' && item.kind === 'Q')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_54, "문의"))
                              : _createCommentVNode("", true),
                            (tab.value === 'A' && item.kind === 'P')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_55, "업데이트"))
                              : _createCommentVNode("", true),
                            (item.status === 'N')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_56, "숨김"))
                              : _createCommentVNode("", true),
                            (isNewNotice(item))
                              ? (_openBlock(), _createElementBlock("span", _hoisted_57, "신규"))
                              : _createCommentVNode("", true),
                            (item.kind === 'Q' && item.answerStatus === 'A')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_58, "답변달림"))
                              : _createCommentVNode("", true),
                            (item.kind === 'Q' && item.secret)
                              ? (_openBlock(), _createBlock(_component_v_icon, {
                                  key: 7,
                                  size: "14",
                                  class: "board-lock"
                                }, {
                                  default: _withCtx(() => [...(_cache[32] || (_cache[32] = [
                                    _createTextVNode("mdi-lock", -1)
                                  ]))]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            _createElementVNode("span", _hoisted_59, _toDisplayString(item.title), 1)
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_60, _toDisplayString(item.authorName || '—'), 1),
                        _createElementVNode("td", _hoisted_61, _toDisplayString(formatDate(item.createdAt)), 1),
                        _createElementVNode("td", _hoisted_62, _toDisplayString(item.hit), 1),
                        _createElementVNode("td", _hoisted_63, _toDisplayString(item.commentCount), 1)
                      ], 10, _hoisted_49))
                    }), 128))
                  ])
                ])),
          (!loading.value && (totalCount.value || pinned.value.length))
            ? (_openBlock(), _createBlock(TablePagination, {
                key: 3,
                "total-count": totalCount.value + pinned.value.length,
                "current-page": page.value,
                "items-per-page": limit.value,
                "total-pages": totalPages.value,
                "page-size-options": [15, 30],
                "onUpdate:currentPage": onPage,
                "onUpdate:itemsPerPage": onLimit
              }, null, 8, ["total-count", "current-page", "items-per-page", "total-pages"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (screen.value === 'write')
      ? (_openBlock(), _createElementBlock("section", _hoisted_64, [
          _createElementVNode("h3", _hoisted_65, _toDisplayString(editingId.value ? '글 수정' : '글쓰기'), 1),
          (!editingId.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                (canNotice.value)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: _normalizeClass({ 'is-on': form.value.kind === 'N' }),
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (form.value.kind = 'N'))
                    }, "공지사항", 2))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  type: "button",
                  class: _normalizeClass({ 'is-on': form.value.kind === 'Q' }),
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (form.value.kind = 'Q'))
                }, "문의요청", 2),
                (canNotice.value)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      type: "button",
                      class: _normalizeClass({ 'is-on': form.value.kind === 'P' }),
                      onClick: _cache[13] || (_cache[13] = ($event: any) => (form.value.kind = 'P'))
                    }, "업데이트", 2))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("label", _hoisted_67, [
            _cache[34] || (_cache[34] = _createElementVNode("span", null, "제목", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((form.value.title) = $event)),
              type: "text",
              maxlength: "120",
              placeholder: "제목을 입력하세요"
            }, null, 512), [
              [_vModelText, form.value.title]
            ])
          ]),
          _createElementVNode("div", _hoisted_68, [
            _cache[35] || (_cache[35] = _createElementVNode("span", null, "내용", -1)),
            (screen.value === 'write')
              ? (_openBlock(), _createBlock(PasteImageField, {
                  key: editorKey.value,
                  modelValue: form.value.body,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((form.value.body) = $event))
                }, null, 8, ["modelValue"]))
              : _createCommentVNode("", true)
          ]),
          (form.value.kind === 'Q')
            ? (_openBlock(), _createElementBlock("label", _hoisted_69, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((form.value.secret) = $event)),
                  type: "checkbox"
                }, null, 512), [
                  [_vModelCheckbox, form.value.secret]
                ]),
                _cache[36] || (_cache[36] = _createElementVNode("span", null, "비밀글 · 작성자와 관리자만 내용을 봅니다", -1))
              ]))
            : _createCommentVNode("", true),
          (form.value.kind === 'N' || form.value.kind === 'P')
            ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                (form.value.kind === 'N')
                  ? (_openBlock(), _createElementBlock("label", _hoisted_71, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((form.value.pinned) = $event)),
                        type: "checkbox"
                      }, null, 512), [
                        [_vModelCheckbox, form.value.pinned]
                      ]),
                      _cache[37] || (_cache[37] = _createElementVNode("span", null, "상단 고정 · 목록 맨 위에 둡니다", -1))
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("label", _hoisted_72, [
                  _cache[39] || (_cache[39] = _createElementVNode("span", null, "상태", -1)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((form.value.status) = $event))
                  }, [...(_cache[38] || (_cache[38] = [
                    _createElementVNode("option", { value: "Y" }, "게시", -1),
                    _createElementVNode("option", { value: "N" }, "숨김", -1)
                  ]))], 512), [
                    [_vModelSelect, form.value.status]
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (formError.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_73, _toDisplayString(formError.value), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_74, [
            _createVNode(_component_v_btn, {
              variant: "text",
              class: "btn-cancel",
              disabled: saving.value,
              onClick: backList
            }, {
              default: _withCtx(() => [...(_cache[40] || (_cache[40] = [
                _createTextVNode("취소", -1)
              ]))]),
              _: 1
            }, 8, ["disabled"]),
            _createVNode(_component_v_btn, {
              variant: "flat",
              class: "btn-save",
              loading: saving.value,
              onClick: save
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(editingId.value ? '저장' : '등록'), 1)
              ]),
              _: 1
            }, 8, ["loading"])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})